import axios from '@axios'

export default {
    namespaced: true,
    state: {
        categoriasLicencias: [],
        choferes: [],
        infracciones: [],
        vehiculos: [],
        listaNegra: [],
    },
    getters: {
        getCategoriasLicencias(state) {
            return state.categoriasLicencias
        },
        getChoferes(state) {
            return state.choferes
        },
        getInfracciones(state) {
            return state.infracciones
        },
        getVehiculos(state) {
            return state.vehiculos
        },
        getListaNegra(state) {
            return state.listaNegra
        },
    },
    mutations: {
        SET_CATEGORIAS_LICENCIAS(state, categoriasLicencias) {
            state.categoriasLicencias = categoriasLicencias
        },
        SET_CHOFERES(state, choferes) {
            state.choferes = choferes
        },
        SET_INFRACCIONES(state, infracciones) {
            state.infracciones = infracciones
        },
        SET_VEHICULOS(state, vehiculos) {
            state.vehiculos = vehiculos
        },
        SET_LISTA_NEGRA(state, listaNegra) {
            state.listaNegra = listaNegra
        },
    },
    actions: {
        fetchInfracciones({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/logistica/infracciones', { params })
                    .then(response => {
                        commit('SET_INFRACCIONES', response.data.data ?? response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        createInfraccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/logistica/infracciones', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updateInfraccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch('/api/auth/logistica/infracciones', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchVehiculos({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/logistica/vehiculos', { params })
                    .then(response => {
                        commit('SET_VEHICULOS', response.data.data ?? response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        createVehiculo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/logistica/vehiculos',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updateVehiculo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/logistica/vehiculos/edit',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchChoferes({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/logistica/choferes', { params })
                    .then(response => {
                        commit('SET_CHOFERES', response.data.data ?? response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        createChofer({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/logistica/choferes',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updateChofer({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/logistica/choferes/edit',
                    data,
                })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCategoriasLicencias({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/logistica/categoriasLicencias', { params })
                    .then(response => {
                        commit('SET_CATEGORIAS_LICENCIAS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchListaNegra({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/logistica/lista_negra', { params })
                    .then(response => {
                        commit('SET_LISTA_NEGRA', response.data.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        createListaNegra({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/logistica/lista_negra', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updateListaNegra({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .patch('/api/auth/logistica/lista_negra', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
